<div id="{{ programEnum }}">
  <section class="container-fluid">
    <div class="d-flex">
      <div class="position-relative w-50 candidature-outer-container">
        <div class="candidature-container">
          <div class="filter-box p-2 d-flex">
            <div><img [src]="'/content/images/home/logo-geracaoz.png'" alt="logo" class="logo-programa" /></div>
            <div class="flex-fill">
              <div class="row">
                <div class="col title">Pesquisa aqui pelo teu projeto</div>
              </div>
              <div class="row" style="margin-bottom: 20px">
                <div class="col-6 description">
                  Nome:
                  <input (change)="filterCandidatures()" [(ngModel)]="nameFilter" class="form-control" />
                </div>
                <div class="col-6 description">
                  Local:
                  <input (change)="filterCandidatures()" [(ngModel)]="locationFilter" class="form-control" />
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="candidatures.length === 0" class="candidature-box">
            <div class="row">
              <div class="col-12 title">Ainda sem projetos disponíveis</div>
            </div>
            <div class="row">
              <div class="col-12 description">Brevemente poderás consultar aqui os projetos disponíveis</div>
            </div>
            <div class="dates-box"></div>
          </div>
          <div (click)="goToCandidature(candidature)" *ngFor="let candidature of candidaturesFiltered" class="candidature-box" id="{{ candidature.id }}">
            <div class="row">
              <!--                        <img *ngIf="candidature.entity.image" class="img-circle" data-ng-src="{{'data:' + candidature.entity.imageContentType + ';base64,' + candidature.entity.image}}"-->
              <!--                             style="max-height: 40px;margin-top: 10px;"/>-->
              <div class="col-12 title">
                {{ candidature.name }}
              </div>
            </div>
            <div class="row">
              <div class="col-12 description" style="padding-bottom: 10px">
                <span [innerHTML]="candidature.synthesis"></span>
              </div>
            </div>
            <div class="dates-box">
              <div class="row dates-label">
                <div class="col-4">Início</div>
                <div class="col-4">Fim</div>
                <div class="col-4">Local</div>
              </div>
              <div class="row dates-text">
                <div class="col-4">{{ candidature.startDate | formatMediumDate }}</div>
                <div class="col-4">{{ candidature.endDate | formatMediumDate }}</div>
                <div class="col-4">{{ getLocations(candidature.locations || []) }}</div>
              </div>
            </div>
          </div>
          <hr />
          <div class="d-flex">
            <button (click)="back()" class="btn-pg btn-vermais mt-2"><fa-icon icon="angle-left"></fa-icon>&nbsp;Voltar</button>
          </div>
        </div>
      </div>
      <div class="w-50">
        <agm-map (mapReady)="mapReady($event)" [latitude]="mapLat" [longitude]="mapLng" [zoom]="zoom">
          <agm-marker (markerClick)="selectCandidature(marker)" *ngFor="let marker of markers" [latitude]="marker.lat" [longitude]="marker.lng" [title]="marker.title"></agm-marker>
        </agm-map>
      </div>
    </div>
  </section>
</div>
